import React from 'react'

import { Level } from '@api/building'

import LevelCard from './level-card'
import { countUnitsByStatus } from './level-explorer-util'
import useLevelDisplayConfig from './use-level-display-config'

interface LevelListProps {
  levels: Level[]
  selectedLevelId: string
  onSelectLevel: (levelId: string) => void
}

function LevelList({ levels, selectedLevelId, onSelectLevel }: LevelListProps) {
  const { levelStagePrefix, availableStatusLabel, availableStatusColour } =
    useLevelDisplayConfig()

  const handleToggleLevel = (levelId: string) => {
    onSelectLevel(levelId !== selectedLevelId ? levelId : '')
  }

  return (
    <ul className="no-scrollbar absolute bottom-0 left-0 top-20 z-8 flex w-[216px] flex-col gap-2 overflow-y-auto px-5 pb-5 xl:top-24 xl:w-[240px] xl:px-8 desktop-all:w-[260px] desktop-large:w-[280px] desktop-large:gap-2.5">
      {levels.map((level) => (
        <li key={level.level}>
          <LevelCard
            label={`${levelStagePrefix} ${level.level}`}
            availableCount={countUnitsByStatus(
              level.data,
              availableStatusLabel
            )}
            availableStatusLabel={availableStatusLabel}
            availableStatusColour={availableStatusColour}
            isSelected={level.level === selectedLevelId}
            isDisabled={!level.data.length}
            onSelect={() => handleToggleLevel(level.level)}
          />
        </li>
      ))}
    </ul>
  )
}

export default LevelList
